//@ts-ignore
import Layout from '@componentsfld/core/Layout'
import { HeadProps } from 'gatsby'
import React, { FunctionComponent } from 'react'
import { IPageContext } from 'Root/Shared/utils/data/buildTypedPage'
import { PuxVWO } from 'Root/Shared/utils/PuxVWO'
import WidgetBuilder from 'Shared/components/builders/WidgetBuilder'
import { BasePage, GenericPageProps } from 'Shared/queries/page-queries'
import PuxMetaTagsGatsby from 'Shared/utils/PuxMetaTagsGatsby'

const PuxHomePage: FunctionComponent<GenericPageProps<BasePage>> = ({
  pageContext,
}) => {
  const pageData = pageContext.pageData
  const headerData = pageContext.headerData
  const footerData = pageContext.footerData

  const editorPath = `widgetZone,widgets`

  return (
    <Layout
      localizedPath={pageData.localization?.localizations}
      pageContentItemId={pageData.contentItemId}
      footerData={footerData}
      headerData={headerData}
      pageProperties={pageContext.pageProperties}
      resStrings={pageContext.resStrings}
    >
      <WidgetBuilder
        widgetBuilderData={pageContext.widgets?.widgetZone}
        pageContentItemId={pageData.contentItemId}
        editorPath={editorPath}
      />
    </Layout>
  )
}

export default PuxHomePage

export function Head(props: HeadProps<never, IPageContext<BasePage>>) {
  return (
    <>
      <PuxMetaTagsGatsby
        {...props.pageContext.metaTags}
        localizedPaths={props.pageContext.pageData.localization?.localizations}
      />
      <PuxVWO isEnabled={props.pageContext.pageProperties?.pagePropertiesVWOEnabled} />
    </>
  )
}
